/**
 * Dice se il percorso inserito è assoluto (sia url che path)
 * @param {string} path
 * @returns {boolean}
 */
export default function isAbsolutePath(path:string):boolean {
    const regex = /^(?:[a-z]+:)?(\/)?\//gmi;    
    return !!path.match(regex);
}